import { Component, OnInit } from '@angular/core';
import { FetchPaymentOptionsForSellerCustomizeService } from '../../../../../shared/services/fetch-payment-options-for-seller-customize.service';

@Component({
  selector: 'app-easykash-add-product',
  templateUrl: './easykash-add-product.component.html',
  styleUrls: ['./easykash-add-product.component.scss']
})
export class EasykashAddProductComponent implements OnInit {
  isQuickPaymentAvailable: boolean = false;
  sellerPaymentOptions: any[] = [];
  isSellerHasQuickQassatly: boolean = false;
  isSellerHasQuickPayment = false;

  constructor(
    private fetchPaymentOptionsForSellerCustomizeService: FetchPaymentOptionsForSellerCustomizeService,
  ) { }

  async ngOnInit() {

    this.fetchPaymentOptionsForSellerCustomizeService.setParams({});
    this.sellerPaymentOptions = await this.fetchPaymentOptionsForSellerCustomizeService.make();
    let filteredArray = this.sellerPaymentOptions.filter((item) => { return item['name'] == "Quick Qassatly" });
    if (filteredArray.length > 0) {
      this.isSellerHasQuickQassatly = true;
    }

    let filteredArray2 = this.sellerPaymentOptions.filter((item) => {
      return item['name'] == 'Credit & Debit Card';
    });
    if (filteredArray2.length > 0) {
      this.isSellerHasQuickPayment = true;
    }
  }

  onAddProduct(servicesButtons: any) {
    servicesButtons.style.display = 'flex';
  }
}
